/**
 * Mode to describe if a legend is isolated/selected or being appended to an existing
 * series selection.
 * @alpha
 */
export var GraphNGLegendEventMode;
(function (GraphNGLegendEventMode) {
    GraphNGLegendEventMode["ToggleSelection"] = "select";
    GraphNGLegendEventMode["AppendToSelection"] = "append";
})(GraphNGLegendEventMode || (GraphNGLegendEventMode = {}));
//# sourceMappingURL=types.js.map